export const updateBrewMenu = /* GraphQL */ `mutation UpdateBrewMenu($input: inputUpdateBrewMenu!) {
	updateBrewMenu(input: $input){
        id
		title
        status
    } 
}`
